import {NgModule} from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule} from '@angular/material-moment-adapter';
import {CustomInputComponent} from './custom-input/custom-input.component';
import {FormsModule} from '@angular/forms';
import {CustomSelectComponent} from './custom-select/custom-select.component';
import {CustomButtonComponent} from './custom-button/custom-button.component';
import {CustomCheckboxComponent} from './custom-checkbox/custom-checkbox.component';
import {CustomInputTimeComponent} from './custom-input-time/custom-input-time.component';
import {CustomRadioGroupComponent} from './custom-radio-group/custom-radio-group.component';
import {CustomTooltipComponent} from './custom-tooltip/custom-tooltip.component';
import {DirectivesModule} from '../directives/directives.module';
import {PipesModule} from '../pipes/pipes.module';
import {CommonModule} from '@angular/common';
import { CustomInputDateComponent } from './custom-input-date/custom-input-date.component';
import {TextFieldModule} from '@angular/cdk/text-field';
import { CustomInputCurrencyComponent } from './custom-input-currency/custom-input-currency.component';
import { CustomMultipleSelectComponent } from './custom-multiple-select/custom-multiple-select.component';
import { BaseSelectComponent } from './base-select/base-select.component';

@NgModule({
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
    ],
    declarations: [
        CustomInputComponent,
        CustomSelectComponent,
        CustomButtonComponent,
        CustomCheckboxComponent,
        CustomInputTimeComponent,
        CustomRadioGroupComponent,
        CustomTooltipComponent,
        CustomInputDateComponent,
        CustomInputCurrencyComponent,
        CustomMultipleSelectComponent,
        BaseSelectComponent
    ],
    imports: [
        MatFormFieldModule,
        FormsModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatTooltipModule,
        MatSlideToggleModule,
        CommonModule,
        DirectivesModule,
        PipesModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatListModule,
        TextFieldModule,
        MatAutocompleteModule
    ],
    exports: [
        CustomInputComponent,
        CustomSelectComponent,
        CustomButtonComponent,
        CustomCheckboxComponent,
        CustomInputTimeComponent,
        CustomInputDateComponent,
        CustomRadioGroupComponent,
        CustomTooltipComponent,
        CustomInputCurrencyComponent,
        MatFormFieldModule,
        MatButtonModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatIconModule,
        MatRadioModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatSelectModule,
        FormsModule,
        CommonModule,
        DirectivesModule,
        PipesModule,
        MatMomentDateModule,
        MatInputModule,
        MatListModule,
        TextFieldModule,
        MatAutocompleteModule,
        CustomMultipleSelectComponent
    ],
})
export class ControlsModule {
}
